module.exports = __webpack_public_path__ + "img/114ne.be84fc5b.svg";